<template>
  <section class="index-steps">
    <h2 class="mb-m section-title text-center">網路投保 簡單 3 步驟</h2>
    <div class="imgs-wrapper">
      <img
        v-for="(img, index) in imgs"
        :key="index"
        :src="img" 
        alt="磐石保險經紀公司-簡單投保-步驟"
      >
    </div>
  </section>
</template>

<script>
  export default {
    data() {
      return {
        imgs: [
          require('@/assets/index-simple-step1.png'),
          require('@/assets/index-simple-step2.png'),
          require('@/assets/index-simple-step3.png'),
          require('@/assets/index-simple-step4.png')
        ]
      };
    }
  };
</script>